import { FooterMobile } from "./FooterMobile";

export { FooterMobile };
